import styled from 'styled-components';

export const Container = styled.section`
  max-width: 75rem;
  margin: 23px 12px;

  ${Styles.desktop`
    margin: 23px auto;
  `}
`;
